// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import OfficialDetailsActionType from './official-details.types';
import {
	officialDetailsAddSuccess,
	officialDetailsAddFailure,
	officialDetailsAddUserResponseChanged,
	economicActivityListSuccess,
	economicActivityListFailure,
	economicActivityListUserResponseChanged,
} from './official-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { officialMemberdetailsAdd, getEconomicActivityList } from './official-details.service';

/** ***************** Official Details Add Start ************************/
export function* OfficialDetails({ payload }: any) {
	try {
		const key = 'OfficialDetailsToken';
		const {
			companyID,
			databaseName,
			memberID,
			economicActivity,
			economicActivitySelectValue,
			center,
			centerSelectValue,
			applicationAmount,
			annualIncome,
			monthlyIncome,
			otherMonthlyIncome,
			perferredLanguage,
			appliedAmount,
			productTypeSelectValue,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			EconomicActivity: economicActivity,
			EconomicActivityID: economicActivitySelectValue,
			Center: center,
			LocationId: centerSelectValue,
			ApplicationAmount: applicationAmount,
			AnnualIncome: annualIncome,
			MonthlyIncome: monthlyIncome,
			OtherMonthlyIncome: otherMonthlyIncome,
			PerferredLanguage: perferredLanguage,
			AppliedAmount: appliedAmount,
			ProductTypeID: productTypeSelectValue,
			OfficerID: userID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(officialMemberdetailsAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(officialDetailsAddFailure(responseData.data));
		} else {
			yield put(officialDetailsAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(officialDetailsAddFailure(error));
	}
}

export function* OfficialDetailsResponseClear() {
	yield put(officialDetailsAddUserResponseChanged());
}

export function* onOfficialDetailsAddStart() {
	yield takeLatest(OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_START, OfficialDetails);
}

export function* onOfficialDetailsAddResponseRest() {
	yield takeLatest(
		OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_RESPONSE_REST_START,
		OfficialDetailsResponseClear,
	);
}
/** ***************** Official Details Add End ************************/

/** ***************** Economic Activity List Start ************************/
export function* EconomicActivityList({ payload }: any) {
	try {
		const key = 'FetchAllEconomicActivityListKey';

		const { companyID, databaseName, EconomicActivityTypeID } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			EconomicActivityTypeID: EconomicActivityTypeID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getEconomicActivityList, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(economicActivityListFailure(responseData.data));
		} else {
			yield put(economicActivityListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(economicActivityListFailure(error));
	}
}

export function* EconomicActivityListResponseClear() {
	yield put(economicActivityListUserResponseChanged());
}

export function* oneconomicActivityListStart() {
	yield takeLatest(OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_START, EconomicActivityList);
}

export function* oneconomicActivityListResponseRest() {
	yield takeLatest(
		OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_RESPONSE_REST_START,
		EconomicActivityListResponseClear,
	);
}
/** ***************** Economic Activity List End ************************/

export function* officialDetailsSaga() {
	yield all([
		call(onOfficialDetailsAddStart),
		call(onOfficialDetailsAddResponseRest),
		call(oneconomicActivityListStart),
		call(oneconomicActivityListResponseRest),
	]);
}
